export const getHTMLTextLength = (html: string) => {
  const div = document.createElement('div') as HTMLDivElement

  div.innerHTML = html

  const charCount = div.innerText.length
  const newLines = div.innerHTML.split('<div>').length - 1
  if (html === "<br>") return 0
  return charCount + newLines
}